// Pizza Wine theme: small progressive enhancements only. Everything works without JS.
(() => {
  // Mobile menu
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.getElementById('mobile-nav');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const min = Number(input.min || 0);
        const next = Math.max(min, Number(input.value || 0) + Number(btn.dataset.step));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main] img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Wholesale form: states we distribute in name the distributor; anywhere else asks for theirs
  const stateSelect = document.querySelector('[data-wholesale-state]');
  if (stateSelect) {
    const distNote = document.querySelector('[data-dist-note]');
    const distName = document.querySelector('[data-dist-name]');
    const otherNote = document.querySelector('[data-other-note]');
    const distField = document.querySelector('[data-distributor-field]');
    const update = () => {
      const opt = stateSelect.selectedOptions[0];
      const picked = !!stateSelect.value;
      const dist = picked && opt ? opt.dataset.distributor : '';
      if (distNote) distNote.hidden = !dist;
      if (distName) distName.textContent = dist || '';
      if (otherNote) otherNote.hidden = !picked || !!dist;
      if (distField) distField.hidden = !picked || !!dist;
    };
    stateSelect.addEventListener('change', update);
    update();
  }
})();

// Header: solid once the page scrolls (used by the see-through homepage header)
(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;
  const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  setH(); onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setH);
  const toggle = document.querySelector('[data-menu-toggle]');
  if (toggle) toggle.addEventListener('click', () => header.classList.toggle('is-menu-open', toggle.getAttribute('aria-expanded') === 'true'));
})();

// Product page: size (or other variant) pills update the variant, price and button
(() => {
  const pills = document.querySelector('[data-variant-pills]');
  if (!pills) return;
  const form = pills.closest('form');
  const idInput = form.querySelector('[data-variant-id]');
  const add = form.querySelector('[data-add]');
  const price = document.querySelector('[data-price]');
  pills.addEventListener('change', (e) => {
    const r = e.target;
    if (!r.matches('input[type="radio"]')) return;
    idInput.value = r.value;
    if (price) price.textContent = r.dataset.price;
    const ok = r.dataset.available === 'true';
    add.disabled = !ok;
    add.textContent = ok ? 'Add to cart' : 'Sold out';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', r.value);
    history.replaceState(null, '', url);
  });
})();

// Autoplaying background videos: one small pause/play icon each; hold still for reduced motion
(() => {
  document.querySelectorAll('[data-video-toggle]').forEach((btn) => {
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    const label = btn.querySelector('[data-video-toggle-label]');
    const set = (paused) => {
      if (paused) video.pause(); else video.play().catch(() => {});
      btn.setAttribute('aria-pressed', String(paused));
      label.textContent = paused ? 'Play video' : 'Pause video';
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) set(true);
    btn.addEventListener('click', () => set(!video.paused));
  });
})();

// Quick add from product cards: add to cart without leaving the page, then bump the header cart count
(() => {
  const forms = document.querySelectorAll('[data-quick-add]');
  if (!forms.length) return;
  const counts = () => document.querySelectorAll('.cart-link__count');
  forms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-quick-add-btn]');
      const label = form.querySelector('[data-quick-add-label]');
      const original = label.textContent;
      btn.disabled = true;
      try {
        const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        counts().forEach((c) => {
          c.textContent = cart.item_count;
          c.setAttribute('aria-label', cart.item_count + ' items');
          c.classList.remove('is-bumped'); void c.offsetWidth; c.classList.add('is-bumped');
        });
        btn.classList.add('is-added');
        label.textContent = btn.classList.contains('card__size') ? '✓' : 'Added ✓';
        setTimeout(() => { btn.classList.remove('is-added'); label.textContent = original; btn.disabled = false; }, 1800);
      } catch (err) {
        // Fall back to the normal form post (goes to the cart page)
        btn.disabled = false;
        form.submit();
      }
    });
  });
})();

// Jump links (e.g. the quick answers' "read more" → /pages/about#who-we-are): scroll to the chapter
// reliably, both when the link is on the same page and when arriving from another page with a #hash.
(() => {
  const go = (id, smooth) => {
    const el = id && document.getElementById(decodeURIComponent(id));
    if (!el) return false;
    const before = window.scrollY;
    el.scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', block: 'start' });
    // if smooth scrolling didn't start (some browsers/settings), jump instead
    if (smooth) setTimeout(() => { if (window.scrollY === before) el.scrollIntoView({ behavior: 'instant', block: 'start' }); }, 400);
    return true;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
    if (go(url.hash.slice(1), true)) { e.preventDefault(); history.pushState(null, '', url.hash); }
  });
  if (location.hash.length > 1) {
    const id = location.hash.slice(1);
    // jump now, then again as images and fonts settle so the chapter stays in view
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    go(id, false);
    [300, 1200].forEach((t) => setTimeout(() => go(id, false), t));
    window.addEventListener('load', () => go(id, false));
  }
})();

// CrushSuite checkout popup: their Date of Birth field is a native date picker that opens on
// today, so shoppers scroll back decades. Swap in a typed MM/DD/YYYY box (number keypad) and
// write the result into their hidden field, which their form still validates and submits.
(() => {
  const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  const pad = (n) => String(n).padStart(2, '0');
  const format = (digits) => [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join('/');

  const toIso = (digits) => {
    if (digits.length !== 8) return '';
    const m = Number(digits.slice(0, 2)), d = Number(digits.slice(2, 4)), y = Number(digits.slice(4));
    const date = new Date(y, m - 1, d);
    const real = date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
    return real && y >= 1900 && date <= new Date() ? `${y}-${pad(m)}-${pad(d)}` : '';
  };

  const enhance = (native) => {
    native.dataset.pwDob = '1';
    const box = document.createElement('input');
    box.type = 'text';
    box.id = 'pw-dob';
    box.className = `${native.className} pw-dob`;
    box.placeholder = 'MM/DD/YYYY';
    box.inputMode = 'numeric';
    box.autocomplete = 'bday';
    box.maxLength = 10;
    box.setAttribute('aria-required', 'true');
    if (native.value) { const [y, m, d] = native.value.split('-'); box.value = `${m}/${d}/${y}`; }
    native.classList.add('pw-dob-native');
    native.tabIndex = -1;
    native.setAttribute('aria-hidden', 'true');
    native.after(box);
    const label = box.nextElementSibling;
    if (label && label.tagName === 'LABEL') label.htmlFor = box.id;
    native.addEventListener('focus', () => box.focus());

    const push = (iso) => {
      if (native.value === iso) return;
      setValue.call(native, iso);
      ['input', 'change'].forEach((t) => native.dispatchEvent(new Event(t, { bubbles: true })));
    };

    box.addEventListener('input', (e) => {
      let digits = box.value.replace(/\D/g, '').slice(0, 8);
      if (e.inputType && e.inputType.startsWith('insert')) {
        // "5" means May and "7" in the day slot means the 7th, so jump ahead for them
        if (/^[2-9]$/.test(digits)) digits = `0${digits}`;
        if (/^\d\d[4-9]$/.test(digits)) digits = `${digits.slice(0, 2)}0${digits[2]}`;
        box.value = format(digits) + (digits.length === 2 || digits.length === 4 ? '/' : '');
      } else {
        box.value = format(digits);
      }
      push(toIso(digits));
    });
    box.addEventListener('blur', () => native.dispatchEvent(new Event('blur', { bubbles: true })));

    // mirror their error state so the red outline lands on the box people can see
    const sync = () => ['aria-invalid', 'aria-describedby'].forEach((a) => {
      if (native.hasAttribute(a)) box.setAttribute(a, native.getAttribute(a)); else box.removeAttribute(a);
    });
    new MutationObserver(sync).observe(native, { attributes: true, attributeFilter: ['aria-invalid', 'aria-describedby'] });
  };

  const scan = () => document.querySelectorAll('[class*="ComplianceCheckForm-module_form__"] input[type="date"]:not([data-pw-dob])').forEach(enhance);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
